const consoleStyling = color => `color: ${color}; font-weight: 900; font-family: "Dank Mono", monospace; font-style: italic; font-size: 1rem`;

/**
 * Log the current state to the terminal
 * @param {object} state -
 * @param {object} action -
 * @param {object} nextState -
 * @returns {undefined} - Logs the state, does not return.
 */
const actionLogger = (state, action, nextState) => {
  console.log('%c Previous state:', consoleStyling('#f39c12'));
  console.log(state);
  console.log('%c --------------------------------------', consoleStyling('#f39c12'));
  console.log('%c Action:', consoleStyling('#2980b9'));
  console.log(`%c ${action.type}`, 'font-weight: bold');
  console.log(action.payload);
  console.log('%c --------------------------------------', consoleStyling('#2980b9'));
  console.log('%c Next state:', consoleStyling('#27ae60'));
  console.log(nextState);
  console.log('%c --------------------------------------', consoleStyling('#27ae60'));
};

module.exports = actionLogger;
